import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";
import { validatePSCLegalName } from "../../../../../utils/validators";
import { hexToRGBA } from "../../../../../utils/theme";

import TextInput from "../../../controls/TextInput";
import Select from "../../../controls/Select";

const StyledContainer = styled.div`
  margin-bottom: 24px;
  border: 1px solid ${hexToRGBA("#000000", 0.1)};

  label[for="legalName"] {
    width: 100%;
  }
`;

const StyledRow = styled(Row)`
  padding: 16px;
`;

function PSCInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Legal information</span>
      </div>
      <StyledRow>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.legalName)}
            label="Legal Name of the Personal Service Corporation"
            defaultInvalidMessage="Please provide a valid corporation name"
            hint={
              <>
                The only punctuation and special characters allowed are hyphen (-) and ampersand (&). The legal name may
                not contain any of the following endings: LLC, PLLC, LC.
              </>
            }
            pattern="(?!.*(?:[ ][lL][cC]$))(?!.*(?:[ ][lL][lL][cC]$))(?!.*(?:[ ][pP][lL][lL][cC]$))^[ a-zA-Z0-9&\\-]+$"
            validate={validatePSCLegalName}
            value={values[FORM_FIELD_KEYS.legalName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.dbaname)}
            label={getFieldProps(FORM_FIELD_KEYS.dbaname)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.dbaname]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12}>
          <Select
            {...getFieldProps(FORM_FIELD_KEYS.organizedState)}
            label={getFieldProps(FORM_FIELD_KEYS.organizedState)?.placeholder?.replace("*", "")}
            value={values[FORM_FIELD_KEYS.organizedState]}
            validated={values.validated}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            hideDivider
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default PSCInfoBlock;
